import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { LOVHeuExtension } from 'app/models/extensions/lov-heu-extension.model';
import { LinkHEUConvention } from 'app/models/link-h-e-u-convention.model';
import { MRMValidators } from '@mrm/core';

export class LOVHeu extends LOVHeuExtension {
  heuDBID: number = 0;
  localName: string = null;
  localNumber: string = null;
  city: string = null;
  provinceDBID?: number = null;
  isActive?: boolean = null;
  orderNumber: number = 0;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  linkHEUConventions: LinkHEUConvention[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      heuDBID: new FormControl({ value: 0, disabled: disableAll }),
      localName: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(100)]),
      localNumber: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(10)]),
      city: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      provinceDBID: new FormControl({ value: null, disabled: disableAll }),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      linkHEUConventions: new FormArray([])
    });


    return form;
  }
}